
import Vue from 'vue'
import axios from 'axios'
import store from '@/store';
import { getStore } from '@/utils/index'
import { resolve } from 'uri-js';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true;

export const MainService = axios.create({
    baseURL: "/", // 主服务
    // baseURL: process.env.MAIN, // 主服务
    timeout: process.env.timeout // request timeout
})

export const LrsService = axios.create({
    baseURL: "/", // 心跳服务
    // baseURL: process.env.LRS, // 心跳服务
    timeout: process.env.timeout // request timeout
})


const interceptorsResponse = (response) => {
    response.headers['Set-Cookies'] = document.cookie
    // console.log("interceptorsResponse===", response.data)
    return Promise.resolve(response.data)
    // return response
}

const interceptorsResponseError = (error) => {
    // console.log("interceptorsResponseError===", error.response.data)
    let data = error.response.data
    if (data.code == 106) {
        Vue.prototype.$EventBus.$emit("remoteLogin", {});
    }
    return Promise.reject(error.response.data)
}

const interceptorsRequest = (config) => {
    return config
}

const interceptorsRequestError = (error) => {
    return Promise.reject(error)
}

const serviceArray = [MainService, LrsService]

serviceArray.forEach((item) => {
    item.interceptors.request.use(interceptorsRequest, interceptorsRequestError)
    item.interceptors.response.use(interceptorsResponse, interceptorsResponseError)
})

export default { MainService, LrsService }



// WEBPACK FOOTER //
// ./src/utils/request.js